export default __webpack_public_path__ + "static/media/dispute.dd33c05e.svg";